// The terms and the privacy policy, as far as the app is concerned: where they
// live, and whether this phone has been shown the current version.
//
// THE NOTICE IS THE ACCEPTANCE. The first step of the welcome says "by
// continuing you agree", with both linked, and pressing Continue is the
// agreement. A phone that finished the welcome before that line existed is
// told once that the terms changed, which the terms themselves promise.
//
// Bump TERMS_VERSION when the terms change materially; everybody who has not
// seen that version is told once.
import { PUBLIC_ORIGIN } from '../app-config.js';
import { isNative } from './core/native.js';
import { prefs } from './core/storage.js';
import { openExternal } from './network.js';

export const TERMS_VERSION = '2026-10-04';
const SEEN_KEY = 'lateagain:terms-seen';

/** The legal pages live on the website, not in the app payload. */
export function legalUrl(path) {
  const origin = isNative ? PUBLIC_ORIGIN : (typeof location !== 'undefined' ? location.origin : PUBLIC_ORIGIN);
  return `${origin}${path}`;
}

export const openTerms = () => openExternal(legalUrl('/terms'));
export const openPrivacy = () => openExternal(legalUrl('/privacy'));

/** Record that this phone has been shown the current terms. */
export function markTermsSeen() {
  prefs[SEEN_KEY] = TERMS_VERSION;
}

/** Has this phone been shown the current terms? */
export function termsSeen(store = prefs) {
  return store[SEEN_KEY] === TERMS_VERSION;
}
